/* PDP scroll-reveal — adds .pdp-reveal--visible when elements come within 100px of the viewport bottom. */
(function () {
  window.__pdpRevealRan = true;

  function reveal() {
    var els = document.querySelectorAll('.pdp-reveal:not(.pdp-reveal--visible)');
    var vpH = window.innerHeight;
    for (var i = 0; i < els.length; i++) {
      var rect = els[i].getBoundingClientRect();
      if (rect.top < vpH - 100 && rect.bottom > 0) {
        els[i].classList.add('pdp-reveal--visible');
      }
    }
  }

  function init() {
    window.__pdpRevealInit = true;
    reveal();
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () { reveal(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', reveal, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
